import { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import AdminHeader from "../../component/AdminHeader";
import ApiRequest from "../../helper/ApiRequest";
import { ApiEndpoints } from "../../helper/ApiEndpoints";
import DataTable from "../../component/DataTable";

const tableHeader = ["URL", "Questions", "Status"];
const tbody = ["url", "faq_count", "status"];

export default function FaqListing() {
  const [data, setData] = useState([]);

  const dataFetch = useCallback(async () => {
    try {
      const response = await ApiRequest("GET", ApiEndpoints.faq.faqList);
      setData((response.faqs || []).map((item) => ({
        ...item,
        faq_count: item.faqs?.length || 0,
      })));
    } catch (error) {
      toast.error(error.response?.data?.message || "Unable to load FAQs.");
    }
  }, []);

  useEffect(() => {
    dataFetch();
  }, [dataFetch]);

  const handleDelete = async (faq_id) => {
    try {
      const response = await ApiRequest("POST", ApiEndpoints.faq.faqDelete, { faq_id });
      if (response.error) {
        toast.error(response.message);
        return;
      }

      toast.success(response.message);
      dataFetch();
    } catch (error) {
      toast.error(error.response?.data?.message || "Unable to delete the FAQ.");
    }
  };

  const pagename = {
    name: "FAQ Management",
    user: "Admin",
    innerpage: "FAQ Management",
  };

  return (
    <>
      <AdminHeader pagename={pagename} />
      <div className="add-btn-section">
        <Link className="admin-add-btn" to="/add-faq">Add +</Link>
        <DataTable
          data={data}
          tableHeader={tableHeader}
          tbody={tbody}
          editPath="edit-faq"
          onDelete={handleDelete}
        />
      </div>
    </>
  );
}
